module.exports = __webpack_public_path__ + "assets/img/d06da673fb005085df62cdbb08385d3b.png";